import createUseStyles from './create/index.js';
import { FontWeights } from './fonts/index.js';

var placementsList = /*#__PURE__*/function (placementsList) {
  placementsList["right"] = "right";
  placementsList["rightStart"] = "right-start";
  placementsList["rightEnd"] = "right-end";
  placementsList["auto"] = "auto";
  placementsList["autoStart"] = "auto-start";
  placementsList["autoEnd"] = "auto-end";
  placementsList["top"] = "top";
  placementsList["topStart"] = "top-start";
  placementsList["topEnd"] = "top-end";
  placementsList["bottom"] = "bottom";
  placementsList["bottomStart"] = "bottom-start";
  placementsList["bottomEnd"] = "bottom-end";
  placementsList["left"] = "left";
  placementsList["leftStart"] = "left-start";
  placementsList["leftEnd"] = "left-end";
  return placementsList;
}({});

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".tooltip-container {\n  --tooltipBackground: #fff;\n  --tooltipBorder: #c0c0c0;\n  --tooltipColor: #000;\n\n  background-color: var(--tooltipBackground);\n  border-radius: 3px;\n  border: 1px solid var(--tooltipBorder);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);\n  color: var(--tooltipColor);\n  display: flex;\n  flex-direction: column;\n  padding: 0.4rem;\n  transition: opacity 0.3s;\n  z-index: 9999;\n}\n\n.tooltip-container[data-popper-interactive='false'] {\n  pointer-events: none;\n}\n\n.tooltip-arrow {\n  height: 1rem;\n  position: absolute;\n  width: 1rem;\n  pointer-events: none;\n}\n\n.tooltip-arrow::before {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  margin: auto;\n  width: 0;\n}\n\n.tooltip-arrow::after {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  margin: auto;\n  position: absolute;\n  width: 0;\n}\n\n.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow {\n  left: 0;\n  margin-top: -0.4rem;\n  top: 0;\n}\n\n.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow::before {\n  border-color: transparent transparent var(--tooltipBorder) transparent;\n  border-width: 0 0.5rem 0.4rem 0.5rem;\n  position: absolute;\n  top: -1px;\n}\n\n.tooltip-container[data-popper-placement*='bottom'] .tooltip-arrow::after {\n  border-color: transparent transparent var(--tooltipBackground) transparent;\n  border-width: 0 0.5rem 0.4rem 0.5rem;\n}\n\n.tooltip-container[data-popper-placement*='top'] .tooltip-arrow {\n  bottom: 0;\n  left: 0;\n  margin-bottom: -1rem;\n}\n\n.tooltip-container[data-popper-placement*='top'] .tooltip-arrow::before {\n  border-color: var(--tooltipBorder) transparent transparent transparent;\n  border-width: 0.4rem 0.5rem 0 0.5rem;\n  position: absolute;\n  top: 1px;\n}\n\n.tooltip-container[data-popper-placement*='top'] .tooltip-arrow::after {\n  border-color: var(--tooltipBackground) transparent transparent transparent;\n  border-width: 0.4rem 0.5rem 0 0.5rem;\n}\n\n.tooltip-container[data-popper-placement*='right'] .tooltip-arrow {\n  left: 0;\n  margin-left: -0.7rem;\n}\n\n.tooltip-container[data-popper-placement*='right'] .tooltip-arrow::before {\n  border-color: transparent var(--tooltipBorder) transparent transparent;\n  border-width: 0.5rem 0.4rem 0.5rem 0;\n}\n\n.tooltip-container[data-popper-placement*='right'] .tooltip-arrow::after {\n  border-color: transparent var(--tooltipBackground) transparent transparent;\n  border-width: 0.5rem 0.4rem 0.5rem 0;\n  left: 6px;\n  top: 0;\n}\n\n.tooltip-container[data-popper-placement*='left'] .tooltip-arrow {\n  margin-right: -0.7rem;\n  right: 0;\n}\n\n.tooltip-container[data-popper-placement*='left'] .tooltip-arrow::before {\n  border-color: transparent transparent transparent var(--tooltipBorder);\n  border-width: 0.5rem 0 0.5rem 0.4em;\n}\n\n.tooltip-container[data-popper-placement*='left'] .tooltip-arrow::after {\n  border-color: transparent transparent transparent var(--tooltipBackground);\n  border-width: 0.5rem 0 0.5rem 0.4em;\n  left: 3px;\n  top: 0;\n}\n";
styleInject(css_248z);

// Todo fix importants @Razzzz
var useStyles = createUseStyles({
  inner: {
    backgroundColor: 'var(--x-bg-17) !important',
    borderRadius: 4,
    border: 'none',
    fontWeight: FontWeights.Medium,
    fontSize: 12,
    lineHeight: '24px',
    textAlign: 'center',
    color: '#ffffff',
    zIndex: function zIndex(props) {
      return props.zIndex;
    }
  },
  arrow: {
    '--tooltipBorder': 'rgba(38, 43, 54, 0)',
    '--tooltipBackground': 'var(--x-bg-17) !important'
  },
  small: {
    padding: '0 8px',
    fontSize: 11
  }
}, {
  name: 'pa-uiLib-tooltip'
});

export { placementsList as p, useStyles as u };
//# sourceMappingURL=styles-S4eQkAfF.js.map
